import { render, staticRenderFns } from "./lifeTechnology.vue?vue&type=template&id=15a83091&"
import script from "./lifeTechnology.vue?vue&type=script&lang=js&"
export * from "./lifeTechnology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports